"use client";

import React from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const defaultToastClassNames = {
  actionButton: "group-[.toaster]:bg-primary group-[.toaster]:text-primary-foreground",
  cancelButton: "group-[.toaster]:bg-muted group-[.toaster]:text-muted-foreground",
  description: "group-[.toast]:text-muted-foreground",
  toast:
    "group toast group-[.toaster]:border-border group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:shadow-lg",
} satisfies NonNullable<NonNullable<ToasterProps["toastOptions"]>["classNames"]>;

const Toaster = ({ toastOptions, ...props }: ToasterProps) => (
  <Sonner
    className="toaster group"
    theme="dark"
    toastOptions={{
      ...toastOptions,
      classNames: {
        ...defaultToastClassNames,
        ...toastOptions?.classNames,
      },
    }}
    {...props}
  />
);

export { Toaster };
